module.exports = __webpack_public_path__ + "img/1.7be39a32.svg";